<script>
import GroupIndex from "../../../abstract/GroupIndex.js";

export default GroupIndex.extend({
  props: {
    subjects: Array
  },
  data() {
    return {
      options: {
        linguistic: null,
        subject: null
      },
      type: "linguistic"
    };
  },
  computed: {
    filteredSubjects() {
      let subjects = _.sortBy(_.uniqBy(this.subjects, "title"), "title");

      return subjects;
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/groups/linguistic/Index.vue